import CryptoJS from "crypto-js";
import { serializeSignParams } from './signature.mjs'
var onkey = CryptoJS.enc.Utf8.parse("abplqo09189kjl38x0al0hfk98yhdfjs")
var EUtils = {
  // key 要设置的cookie的key
  // value 要存储的值
  // expires 过期时间(毫秒)
  setCookie: function(key, value, expires, path) {
    let str = key + '=' + value
    if (expires != undefined) { // 不设定过期时间，浏览器关闭时cookie自动消失
      const date = new Date()
      date.setTime(date.getTime() + expires)
      str += '; expires=' + date.toUTCString()
    }
    if (path) str += '; Path=' + path
    str += '; SameSite=Lax'
    if (window.location.protocol === 'https:') str += '; Secure'
    document.cookie = str
  },
  getCookie: function(key) {
    /* 获取cookie参数*/
    const name = key + '='
    var arrCookie = document.cookie.split(';')
    let result
    for (let i = 0; i < arrCookie.length; i++) { // 使用for循环查找cookie中的tips变量
      const arr = arrCookie[i].split('=') // 将单条cookie用"等号"为标识，将单条cookie保存为arr数组
      const cookieName = arr[0].trim()
      if (key == cookieName) { // 匹配变量名称，其中arr[0]是cookie名称，如果与要取的KEY相同，则取出arr[1]的value
        result = arr[1]
        break // 终止for循环遍历
      }
    }
    return result
  },
  getIdentityPath: function() {
    for (const key of ['identityPathV2', 'identityId']) {
      try {
        const path = JSON.parse(this.getCookie(key) || 'null')
        if (Array.isArray(path) && path.length && path.every(id =>
          (typeof id === 'string' || typeof id === 'number') && String(id).trim() !== ''
        )) return path
      } catch (_) { /* Fall back to the legacy selection on first upgrade. */ }
    }
    return []
  },
  setIdentityPath: function(path, expires) {
    const value = JSON.stringify(path)
    // A new root cookie avoids older same-name cookies scoped to nested pages.
    this.setCookie('identityPathV2', value, expires, '/')
    this.setCookie('identityId', value, expires, '/')
  },
  delCookie: function(key) {
    document.cookie = key + '=v; expires=' + (new Date(0)).toUTCString() + '; SameSite=Lax' + (window.location.protocol === 'https:' ? '; Secure' : '') // 设置之前的任意时间即可删除cookie
  },
  getStorage: function(key, type) {
    type = type == undefined ? 'session' : type
    let result = ''
    switch (type) {
      case 'session':
        result = window.sessionStorage.getItem(key)
        break
      case 'local':
        result = window.localStorage.getItem(key)
        break
      case 'cookie':
        result = this.getCookie(key)
        break
    }
    return result
  },
  setStorage: function(key, value, type, expires) {
    type = type == undefined ? 'session' : type
    const result = ''
    switch (type) {
      case 'session':
        window.sessionStorage.setItem(key, value)
        break
      case 'local':
        window.localStorage.setItem(key, value)
        break
      case 'cookie':
        this.setCookie(key, value, expires)
        break
    }
    return true
  },
  delStorage: function(key, type) {
    type = type == undefined ? 'session' : type
    const result = ''
    switch (type) {
      case 'session':
        window.sessionStorage.removeItem(key)
        break
      case 'local':
        window.localStorage.removeItem(key)
        break
      case 'cookie':
        this.delCookie(key)
        break
    }
    return true
  },
  /*
     * 创建随机数
     */
  createUuid: function(prefix,len) {
    prefix = prefix ? prefix + '_' : ''
    var len = len ? len : 16
    /* 32长度*/
    var radix = 62
    /* 16进制*/
    var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
    var uuid = []
    var i
    radix = radix || chars.length

    if (len) {
      for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix]
    } else {
      var r
      uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
      uuid[14] = '4'
      for (i = 0; i < 36; i++) {
        if (!uuid[i]) {
          r = 0 | Math.random() * 16
          uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r]
        }
      }
    }

    var id = prefix + uuid.join('')
    return id
  },
  /*
     * 判断是否是函数
     */
  isFunction: function(variable) {
    return (typeof variable === 'function') && variable.constructor == Function
  },

  /*
     * 判断是否是对象
     */
  isObject: function(variable) {
    return (typeof variable === 'object') && variable.constructor == Object
  },

  /*
     * 判断是否是数组
     */
  isArray: function(variable) {
    return (typeof variable === 'object') && variable.constructor == Array
  },

  /*
     * 判断是否是字符串
     */
  isString: function(variable) {
    return (typeof variable === 'string') && variable.constructor == String
  },

  /*
     * 判断是否是数字
     * variable 判断的值
     * strict 是否严格匹配：0非严格匹配（默认），1严格匹配（数据类型也必须是数值型）
     */
  isNumber: function(variable, strict) {
    strict = strict == undefined ? 0 : 1
    if (strict) {
      return (typeof variable === 'number') && variable.constructor == Number// 严格匹配 ，类型也必须是数值型
    } else {
      return /^(-?\d+)(\.\d+)?$/.test(variable)// 正则验证所有数字：整数、浮点数、负数等
    }
  },

  /*
     * 判断是否是日期对象
     */
  isDate: function(variable) {
    return (typeof variable === 'object') && variable.constructor == Date
  },

  /*
     * 判断对象或者数组是否为空，是否是空字符串
     */
  isEmpty: function(variable) {
    for (const item in variable) { // 遍历传入的对象或者数组
      if (variable.hasOwnProperty(item)) {
        return false// 如果可以进入循环，且该属性属于此对象
      }
    }
    return true
  },
  /*
     * 日期时间格式化：将时间对象或者时间戳转成自定义格式的时间字符串
     * datetime 要格式化的日期时间对象或者时间戳
     * format 时间格式化的模板格式，例如：yyyy-mm-dd hh:ii:ss
     */
  dateFormat: function(datetime, format) {
    let dt = ''
    datetime = this.isString(datetime) ? datetime.replace(/\-/g, '/') : datetime
    if (/^\d+$/.test(datetime) || Date.parse(datetime)) { // 如果是时间戳，转成日期对象
      dt = new Date(datetime)
    } else if (isNaN(datetime)) {
      return ''// 如果时间不对，则返回空
    } else {
      dt = datetime
    }
    let fmt = format == undefined ? 'yyyy-mm-dd' : format
    // 格式化正则替换映射定义（最多两位）
    const rep = {
      'm+': dt.getMonth() + 1, // 月
      'd+': dt.getDate(), // 日
      'h+': dt.getHours(), // 时
      'i+': dt.getMinutes(), // 分
      's+': dt.getSeconds(), // 秒
      'q+': Math.floor((dt.getMonth() + 3) / 3), // 季（当前是第几季度）
      'e+': dt.getMilliseconds()// 毫秒
    }
    if (/(y+)/.test(fmt)) { // 针对年份，单独处理
      fmt = fmt.replace(RegExp.$1, (dt.getFullYear() + '').substr(4 - RegExp.$1.length))// 取出具体年份，替换格式里的yyyy符号，根据y的个数截取后N位，最多4位
    }
    for (const k in rep) { // 循环所有对应的替换规则，逐一替换
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (rep[k]) : (('00' + rep[k]).substr(('' + rep[k]).length)))// 只保留一位的直接替换，两位的前拼“00”，截取后两位再替换，保证每一项都是两位
      }
    }
    return fmt// 返回替换后的结果
  },
  /*
  * 获取URL的?后边的指定key的参数
  * url 要获取参数的url地址
  * key url参数对应的key
  * 返回指定key的值
  */
  getParamFromUrl: function (url, key) {
    let reg = new RegExp(`(\\?|&)${key}=([^&]+)`);
    let result = '';
    url.replace(reg, function () {
      result = decodeURIComponent(arguments[2]);
    });
    return result;
  },

  /*
   * 获取URL的?后边的字符串，对应的所有参数
   * url 要获取参数的url地址
   * key url参数对应的key
   * 返回所有参数的key=>value的数组
   */
  getQueryFromUrl: function (url) {
    let data = {};
    let query = url.split("?")[1];
    if (query) {
      let param = query.split("&");
      for (let item in param) {
        if (param[item].indexOf("=") != -1) {
          data[param[item].split('=')[0]] = decodeURIComponent(param[item].split('=')[1]);
        }
      }
    }
    return data;
  },
  /*
     * 计算两个日期之间的差
     * date1 第一个日期，建议格式：yyyy-mm-dd hh:ii:ss
     * date2 第二个日期，建议格式：yyyy-mm-dd hh:ii:ss
     * type  计算类型：默认分钟；年（y）月（m）日（d）时（h）分（i）秒（s）
     * isAbs 是否绝对值，默认true
     */
  getDateDiff: function (date1, date2, type, isAbs) {
    let d1 = Date.parse(date1);// 将标准日期格式转成数字毫秒
    let d2 = Date.parse(date2);// 不是合法的日期，转换后的值为NaN
    if (!this.isNumber(d1) || !this.isNumber(d2)) {
      return false;// 如果两个日期有一个不合法，则返回false
    }
    type = type == undefined ? 'i' : type.toLowerCase();// 设置默认值，并将传入值转小写
    isAbs = isAbs == undefined ? true : isAbs;
    let typeDate = type.substr(0, 1);// 获取真正的日期处理类型（取字符串第一位）
    let typeDecimal = type.substr(-1);// 获取计算后保留的小数位数
    let divisor = 1;
    switch (typeDate) {
      case 'i':// 分
        divisor = 60;// 60秒是一分钟
        break;
      case 'h':// 时
        divisor = 3600;// 3600秒是一个小时
        break;
      case 's':// 秒
        divisor = 1;
        break;
      case 'd':// 日
        divisor = 3600 * 24;// 86400秒是一天
        break;
      case 'm':// 月
      case 'y':// 年
        return this.dateMonthDiff(date1, date2, type, isAbs);// 月和年特殊处理
        break;
      default:
        divisor = 60;// 默认按分钟计算
    }
    let result = 0;
    if (typeDecimal == typeDate) {// 取整
      if (isAbs) {
        result = Math.abs(parseInt((d2 - d1) / 1000 / divisor));// JS日期转时间戳，单位是毫秒，除以1000后才是秒
      } else {
        result = parseInt((d2 - d1) / 1000 / divisor);// JS日期转时间戳，单位是毫秒，除以1000后才是秒
      }
    } else {
      typeDecimal = this.isNumber(typeDecimal) ? parseInt(typeDecimal) : 0;// 处理typeDecimal的数据类型，保证是数字
      if (isAbs) {
        result = this.round((Math.abs(d2 - d1) / 1000 / divisor), typeDecimal);
      } else {
        result = this.round(((d2 - d1) / 1000 / divisor), typeDecimal);
      }
    }
    return result;
  },
  /*
    * 计算两个日期之间的年或者月差
    * 每年的天数不固定，每个月的天数也不固定，不能通过秒差除以固定的数值计算差值
    * date1 第一个日期，建议格式：yyyy-mm-dd hh:ii:ss
    * date2 第二个日期，建议格式：yyyy-mm-dd hh:ii:ss
    * type  计算类型：默认空，也就是月；年（y）月（m）
    * isAbs 是否绝对值，默认true
    */
  dateMonthDiff: function (date1, date2, type, isAbs) {
    type = type == undefined ? '' : type.toLowerCase();// 设置默认值，并将传入值转小写
    date1 = this.dateFormat(date1, "yyyy-mm-dd");
    date2 = this.dateFormat(date2, "yyyy-mm-dd");
    date1 = date1.split('-');// 拆分年月日，只需要年和月部分
    date2 = date2.split('-');// 拆分年月日，只需要年和月部分
    let year1 = parseInt(date1[0]);
    let month1 = parseInt(date1[1]);
    let year2 = parseInt(date2[0]);
    let month2 = parseInt(date2[1]);
    let result = '';
    if (type == 'y') {// 返回相差的年
      if (isAbs) {
        return Math.abs(year2 - year1);// 计算年份差值，使用绝对值函数可以忽略两个日期的大小顺序
      } else {
        return year2 - year1;// 计算年份差值，使用绝对值函数可以忽略两个日期的大小顺序
      }
    }
    if (isAbs) {
      return Math.abs(year2 - year1) * 12 + Math.abs(month2 - month1);// 计算月份差值，使用绝对值函数可以忽略两个日期的大小顺序
    } else {
      return (year2 - year1) * 12 + (month2 - month1);// 计算月份差值，使用绝对值函数可以忽略两个日期的大小顺序
    }
  },
  /*
     * 数字格式化，千分位
     * num 要格式化的数字
     * is_thousands 是否增加千分位，1设置千分位，0步设置
     * keep_decimal 保留小数类型和位数：{round:2}四舍五入保留两位，{int:2}直接舍去保留两位
     */
  numberFormat: function(num, is_thousands, keep_decimal) {
    is_thousands = is_thousands == undefined ? 0 : is_thousands
    if (this.isObject(keep_decimal)) {
      if (keep_decimal.hasOwnProperty('round')) {
        num = this.round(num, keep_decimal.round)
      } else if (keep_decimal.hasOwnProperty('int')) {
        num = this.int(num, keep_decimal.int)
      }
    }
    if (is_thousands) { // 针对小数和整数，用不同的正则处理
      num = (num + '').replace(((num + '').indexOf('.') > -1) ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g, '$1,')
    }
    return num
  },
  /*
    * 四舍五入函数
    * val 要处理的数字
    * num 保留的小数位数
    */
  round: function (val, num) {
    if (!this.isNumber(val)) {
      return val;// 要操作的数必须数字，否则返回原值
    }
    let number = this.getComputeNumber(num);
    let result = Math.round(val * number) / number;// 计算结果
    return this.getComputeResult(val, num, result);
  },
  /*
 * 计算保留小数位数时，需要特殊处理的数字
 * num 保留的小数位数
 */
  getComputeNumber: function (num) {
    num = isNaN(parseInt(num)) ? 0 : parseInt(num);// 如果保留小数位数非数字，则默认不保留小数
    let number = 1;
    for (let i = 0; i < num; i++) {
      number *= 10;// 每多一位数，则数据处理的倍数乘10
    }
    return number;
  },
  /*
 * 数据处理时：小数保留位数处理
 */
  getComputeResult: function (val, num, result) {
    let point = "";// 是否有小数点
    if (num > 0) {
      if (/^-?\d+$/.test(result)) {// 判断结果数字中是否有小数点，没有则拼上一个
        point = ".";
      }
      result = result + point + "0000000000";// 小数位数处理
      let pos = result.indexOf(".");// 查找小数点的位置
      result = result.substr(0, (num + pos + 1));// 保持格式截取最终结果
    }
    return result;
  },
  /*
     * 针对字符串中的数字格式化，千分位
     * str 要格式化的数字
     * is_thousands 是否增加千分位，1设置千分位，0步设置
     * keep_decimal 保留小数类型和位数：{round:2}四舍五入保留两位，{int:2}直接舍去保留两位
     */
  strNumberFormat: function(str, is_thousands, keep_decimal) {
    const regExp = /\d+(\.\d+)?/g
    str = str.replace(regExp, function(match) {
      return EUtils.numberFormat(match, is_thousands, keep_decimal)
    })
    return str
  },
  deepClone(target) {
    let result
    if (typeof target === 'object') {
      if (Array.isArray(target)) {
        result = []
        for (const i in target) {
          result.push(this.deepClone(target[i]))
        }
      } else if (target === null) {
        result = null
      } else if (target.constructor == RegExp) {
        result = target
      } else {
        result = {}
        for (const i in target) {
          result[i] = this.deepClone(target[i])
        }
      }
    } else {
      result = target
    }
    return result
  },
  /*
 * 截取字符串长度，支持中文（算两个长度）
 * str 要统计的字符串
 * n 要截取的长度
 * isSuffix 是否拼接"..."后缀，超出长度拼接的后缀
 * suffix 后缀符号
 * 返回长度
 */
  subStr: function(str, n, isSuffix, suffix) {
    if (str == undefined) {
      return false
    }
    if (n == undefined) {
      return str
    }
    isSuffix = isSuffix == undefined ? true : isSuffix// 设置默认值
    suffix = suffix == undefined ? '...' : suffix// 设置默认值
    if (isSuffix) { // 如果拼接，则需要单独处理
      const len = this.getStrLength(str)
      if (len > n) { // 如果传入的字符串长度，比要截取的长度长，则需要拼接“...”
        n -= 2//
      }
    } else { // 如果选择不拼结尾，那么就清空结尾符号变量
      suffix = ''
    }
    const reg = /[^\x00-\xff]/g
    if (str.replace(reg, 'mm').length <= n) {
      return str
    }
    const m = Math.floor(n / 2)
    for (let i = m; i < str.length; i++) {
      if (str.substr(0, i).replace(reg, 'mm').length >= n) {
        return str.substr(0, i) + suffix
      }
    }
    return str
  },
  /*
     * 获取字符串长度，支持中文（算两个长度）
     * str 要统计的字符串
     * 返回长度
     */
  getStrLength: function(str) {
    const len = str.length
    let sum = 0
    for (let i = 0; i < len; i++) {
      if ((str.charCodeAt(i) & 0xff00) != 0) {
        sum++
      }
      sum++
    }
    return sum
  },

  /*
     * 简单过滤lucene语法
     * str
     * 返回过滤的字符串
     */
  handleLucene: function(str) {
    let search = str // 输入框内容
    let searchString = ''
    if (search) {
      search = search.replace(/\//g, '\\\\/')
      search = search.replace(/：/g, ':')
      search = search.replace(/ and /ig, ' AND ')
      search = search.replace(/ not /ig, ' NOT ')
      searchString += search
    }
    searchString = searchString.trim()
    return searchString
  },
  /*
     * 简单时间转换 20220311=》2022-03-11
     * str
     * 返回过滤的字符串
     */
  filtertime(timeStr) {
    return timeStr.substring(0, 4) + '-' + timeStr.substring(4, 6) + '-' + timeStr.substring(6, 9)
  },
  /*
     * 字符串正则匹配
     * str
     * 返回过滤的字符串
     */
  handleParams(searchData) {
    let search = searchData // 输入框内容
    let searchString = ''
    if (search) {
      search = search.replace(/\//g, '\\/')
      search = search.replace(/：/g, ':')
      search = search.replace(/ and /ig, ' AND ')
      search = search.replace(/ not /ig, ' NOT ')
      searchString += search
    }
    searchString = searchString.trim()
    return searchString
  },
  getDevice(data){//获取当前设备类型
    if(data){
      EUtils.device = data;
    }
  },
  callhandler(name, res) {//透传给设备端
    let result={
      "method":name,
      "data":res
    }
    try {
      if(EUtils.device == 'ios'){//iOS
        window.webkit.messageHandlers['callBackValue'].postMessage(result)
      }else if(EUtils.device == 'android'){
        window.Android['callBackValue'](JSON.stringify(result))
      }
    }catch (e){

    }
  },
  Filternull(arys) {
    var srt = {};
    if(arys){
      for (let i in arys) {
        if(arys[i]){
          srt[i] = arys[i]
        }
      }
    }
    return srt;
  },
  objKeySort(arys) {
    return serializeSignParams(arys)
  },
  formatEscapedLineBreaks(str) {
    if (typeof str !== 'string') return str;
    return str.includes('\\n') ? str.replace(/\\n/g, '<br>') : str;
  },
  decode (input) {
    var output = "";
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0;
    if (input==undefined||input==null){
    }else {
      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
      while (i < input.length) {
        enc1 = this.keyStr.indexOf(input.charAt(i++));
        enc2 = this.keyStr.indexOf(input.charAt(i++));
        enc3 = this.keyStr.indexOf(input.charAt(i++));
        enc4 = this.keyStr.indexOf(input.charAt(i++));
        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;
        output = output + String.fromCharCode(chr1);
        if (enc3 != 64) {
          output = output + String.fromCharCode(chr2);
        }
        if (enc4 != 64) {
          output = output + String.fromCharCode(chr3);
        }
      }
      output = this._utf8_decode(output);
      return output;
    }
  },
  _utf8_decode  (utftext) {
    var string = "";
    var i = 0;
    var c = c1 = c2 = 0;
    var c1 = 0;
    var c2 = 0;
    var c3 = 0;
    while ( i < utftext.length ) {
      c = utftext.charCodeAt(i);
      if (c < 128) {
        string += String.fromCharCode(c);
        i++;
      } else if((c > 191) && (c < 224)) {
        c2 = utftext.charCodeAt(i+1);
        string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
        i += 2;
      } else {
        c2 = utftext.charCodeAt(i+1);
        c3 = utftext.charCodeAt(i+2);
        string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        i += 3;
      }
    }
    return string;
  },
  decrypted(param,iv2) {
    var iv3 = CryptoJS.enc.Base64.parse(iv2)
    var decrypted = CryptoJS.AES.decrypt(param, onkey , {
      iv: iv3,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    decrypted = CryptoJS.enc.Utf8.stringify(decrypted);
    return decrypted;
  },
  payformat(pay){
    let name =''
    if(pay=='alipay'){
      name = '支付宝'
    }else if(pay=='alipay_h5'){
      name = '支付宝h5'
    }else if(pay=='wx'){
      name = '微信app'
    }else if(pay=='wx_mini'){
      name = '微信小程序'
    }else if(pay=='apple'){
      name = '苹果支付'
    }else if(pay == 'tikTok'){
      name = '抖音支付'
    }else if(pay=='wx_scan'){
      name = '网页微信'
    }
    return name;
  },
  async isLinkValid(url) {
    // 1. 先检查 URL 格式
    try {
      new URL(url);
    } catch {
      return false;
    }
    // 2. 根据类型选择检测方式
    if (url.match(/\.(jpg|jpeg|png|gif|webp)$/i)) {
      return await this.isImageURLValid(url);
    } else if (url.match(/\.(mp4|webm|ogg)$/i)) {
      return await this.isVideoURLValid(url);
    } else {
      // 其他类型，尝试 fetch（注意 CORS）
      try {
        const res = await fetch(url, { method: 'HEAD', mode: 'no-cors' });
        return true;
      } catch {
        return false;
      }
    }
  },
  shuffleArray(array) {
    const shuffled = [...array]; // 创建副本，不修改原数组
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  },
  isVideoURLValid(url) {
    return new Promise((resolve) => {
      const video = document.createElement('video');
      video.preload = 'metadata';
      video.onloadedmetadata = () => resolve(true);
      video.onerror = () => resolve(false);
      video.src = url;
    });
  },
  isImageURLValid(url) {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
      img.src = url;
    });
  },
  imgUrl: 'https://skos.shangkao.com.cn/',
  fileUrl:'',
  keyStr : "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
  device:'android'
}
import Vue from 'vue'
export const EventBus = new Vue();
window['EUtils'] = EUtils
window.getDevice = EUtils.getDevice//当前设备类型
